import { modifier } from 'ember-modifier';

export default modifier(
    function updateUIValue(element, properties, { value, handleChange }) {
        element.value = value;
        if (handleChange) handleChange();
    },
    { eager: false },
);
